function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{display:inline;fill:#FFFFFF;}\r\n\t.st3{display:inline;fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,4;}\r\n\t.st4{display:inline;fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{display:inline;opacity:0.2;fill:#0F63F2;enable-background:new    ;}\r\n\t.st6{display:inline;fill:#6C63FF;}\r\n\t.st7{display:inline;opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st8{display:inline;fill:#0F63F2;}\r\n\t.st9{display:inline;fill:#B0BEC5;}\r\n\t.st10{fill:none;stroke:#B0BEC5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  className: "st0"
}, React.createElement("rect", {
  x: 7.6,
  y: 73.5,
  className: "st1",
  width: 85.7,
  height: 42.4
}), React.createElement("rect", {
  x: 8.5,
  y: 74.4,
  className: "st2",
  width: 83.9,
  height: 40.2
}), React.createElement("line", {
  className: "st3",
  x1: 13,
  y1: 79.8,
  x2: 13,
  y2: 108.8
}), React.createElement("line", {
  className: "st4",
  x1: 12.7,
  y1: 110.8,
  x2: 86.8,
  y2: 110.8
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 81.3,
  x2: 78.8,
  y2: 81.3
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 88,
  x2: 78.8,
  y2: 88
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 94.7,
  x2: 78.8,
  y2: 94.7
}), React.createElement("line", {
  className: "st4",
  x1: 21.2,
  y1: 101.4,
  x2: 78.8,
  y2: 101.4
}), React.createElement("path", {
  className: "st5",
  d: "M25,110.8V94.7c0,0-1.3-6.9,12.3-6.7c12.4-1.8,12.4-6.9,12.4-6.9s11.4-1.2,12,10.9c0.1,2,1.1,3.9,2.7,5.1 c4.7,3.3,8.8-3.3,10.6-9.1v22.8H25z"
}), React.createElement("circle", {
  className: "st6",
  cx: 36.2,
  cy: 87.8,
  r: 1.8
}), React.createElement("circle", {
  className: "st7",
  cx: 36.2,
  cy: 87.8,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 36.2,
  cy: 87.8,
  r: 2.2
}), React.createElement("circle", {
  className: "st6",
  cx: 25,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 25,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st6",
  cx: 49.7,
  cy: 81.5,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 49.7,
  cy: 81.5,
  r: 1.8
}), React.createElement("circle", {
  className: "st6",
  cx: 62.1,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 62.1,
  cy: 94.9,
  r: 1.8
}), React.createElement("circle", {
  className: "st6",
  cx: 75,
  cy: 88.7,
  r: 1.8
}), React.createElement("circle", {
  className: "st8",
  cx: 75,
  cy: 88.7,
  r: 1.8
}), React.createElement("rect", {
  x: 8,
  y: 121.4,
  className: "st9",
  width: 84.9,
  height: 1.5
}), React.createElement("rect", {
  x: 8,
  y: 125.4,
  className: "st9",
  width: 84.9,
  height: 1.5
}), React.createElement("rect", {
  x: 8,
  y: 129.3,
  className: "st9",
  width: 84.9,
  height: 1.5
}), React.createElement("rect", {
  x: 8,
  y: 133.2,
  className: "st9",
  width: 84.9,
  height: 1.5
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2_1_"
}, React.createElement("polygon", {
  className: "st10",
  points: "25.4,113.3 25.4,36.8 62,36.8 74.6,49.4 74.6,113.3  "
}), React.createElement("polygon", {
  className: "st10",
  points: "62,49.4 74.6,49.4 62,36.8  "
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  d: "M48.6,78.5c0.3-1,0.7-1.9,1.1-2.7c0.4-0.7,1-1.6,1.7-2.5c0.5-0.7,0.9-1.3,1.2-1.7c0.3-0.5,0.5-1,0.7-1.5 c0.2-0.5,0.3-1.1,0.3-1.8v0c0-1.3-0.3-2.2-0.9-2.9s-1.5-1-2.6-1c-1.2,0-2.1,0.4-2.7,1.2s-1,2-1,3.5v0H43v0c0-1.6,0.4-3,0.9-4.2 s1.4-2,2.4-2.6c1-0.6,2.2-0.9,3.6-0.9c1.5,0,2.7,0.3,3.8,0.8c1,0.5,1.8,1.3,2.4,2.4c0.5,1,0.8,2.3,0.8,3.7v0c0,0.9-0.1,1.7-0.4,2.4 s-0.5,1.3-0.9,1.9s-0.8,1.2-1.4,1.9c-0.7,0.8-1.2,1.5-1.6,2.2c-0.4,0.6-0.7,1.4-1,2.3s-0.4,1.9-0.4,3h-3.2 C48.1,80.7,48.3,79.5,48.6,78.5z M48.1,85.4h3.2v3.2h-3.2V85.4z"
}));

var SvgGeneric = function SvgGeneric(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 150",
    style: {
      enableBackground: "new 0 0 100 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneric, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/generic.6a73b0ea.svg";
export { ForwardRef as ReactComponent };